// 登录模式
import { atom } from "jotai";
import { buildURL, getLoginMethodSet, getLoginUnifySet } from "API/auth";

// 允许的登录方式
export const loginModeAtom = atom(getLoginMethodSet);

// 统一身份认证配置
export const loginUnifySetAtom = atom(async () => {
    const data = await getLoginUnifySet();

    const { loginUrl, responseType, clientId, rollBackUrl, scope, state } =
        data;

    const href = buildURL(
        `response_type=${responseType}`,
        `client_id=${clientId}`,
        `redirect_uri=${rollBackUrl}`,
        `scope=${scope}`,
        `state=${state}`
    );

    const ssoUrl = `${loginUrl}?${href}`;
    return { ...data, ssoUrl };
});
